import { inject, InjectionToken } from '@angular/core'
import { Route } from '@angular/router'
import {
  DEFAULT_URL_MATCHER,
  UrlMatcherFactory,
  UrlMatcherService,
} from '@spartacus/core'
import { getSuffixUrlMatcher } from '@spartacus/storefront'

export function getProductDetailsUrlMatcherFactory (service: UrlMatcherService,
                                                    defaultMatcherFactory: UrlMatcherFactory): UrlMatcherFactory {
  const factory = (route: Route) => {
    const defaultMatcher = defaultMatcherFactory(route)
    const mbSuffixPDPMatcher = getSuffixUrlMatcher({
      marker: 'products',
      paramName: 'productCode'
    })
    return service.getCombined([defaultMatcher, mbSuffixPDPMatcher])
  }
  return factory
}

/**
 * Injection token with url matcher factory for PDP.
 * The provided url matcher matches both:
 * - the configured `paths` from routing config and
 * - custom pattern  `** / products / :urlEncodedName`
 */
export const MB_PRODUCT_DETAILS_URL_MATCHER = new InjectionToken<UrlMatcherFactory>(
  'MB_PRODUCT_DETAILS_URL_MATCHER',
  {
    providedIn: 'root',
    factory: () =>
      getProductDetailsUrlMatcherFactory(
        inject(UrlMatcherService),
        inject(DEFAULT_URL_MATCHER)
      ),
  }
)
